//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.CurveAlignedListBuilder.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.UnitCellBuilder.js";
import "../GeometricUtilities/GeometricUtilities.VoronoiItemListBuilder.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Fields.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AlignAtSplitCurve",1,0],[0,"AngularThreshold",1,0],[1,"AverageFacetSize",0,"Expression",0],[1,"BallDiameter",0,"Expression",0],[0,"BallDiameterField",0,"Fields.ScalarFieldWrapper",0],[0,"BallsOption",1,0],[1,"BaseFace",0,"ScCollector",0],[1,"BlendFactor",0,"Expression",0],[1,"BoundaryBody",0,"ScCollector",0],[1,"ChordalTolerance",0,"Expression",0],[0,"ContourPoint1",1,"Point",0],[0,"ContourPoint2",1,"Point",0],[0,"ContourPoint3",1,"Point",0],[0,"ContourPoint4",1,"Point",0],[0,"Csys",1,"CoordinateSystem",0],[1,"CurveAlignedList",0,"GeometricUtilities.CurveAlignedListBuilder",0],[1,"FactorToRodDiameter",0,"Expression",0],[1,"FilterToolFace",0,"ScCollector",0],[0,"IsRandom",1,0],[0,"LatticeType",1,0],[0,"LatticeVersion",1,0],[0,"Layers",1,0],[0,"LockAtBoundary",1,0],[1,"MaxDeviation",0,"Expression",0],[1,"MaxEdgeLength",0,"Expression",0],[0,"MinimumRodNumber",1,0],[1,"Offset",0,"Expression",0],[0,"OptimizationIterations",1,0],[0,"OrientationPoint1",1,"Point",0],[0,"OrientationPoint2",1,"Point",0],[0,"OutputType",1,0],[0,"Parameterization",1,0],[1,"PoreSize",0,"Expression",0],[0,"PushNodesUnderFace",1,0],[0,"RemeshMode",1,0],[0,"RemoveDanglingRods",1,0],[0,"RemoveDisconnectedRods",1,1],[0,"RemoveDisconnectedRods2",1,0],[0,"ReverseFaceDirection",1,0],[0,"RodDiameter",0,"Fields.ScalarFieldWrapper",0],[0,"SharpEdgesLockOption",1,0],[0,"SnipAtBoundary",1,0],[0,"Source",1,0],[0,"SpecifyLayers",1,0],[1,"SplitCurve",0,"Section",0],[0,"TessellationFactor",1,0],[0,"ThicknessType",1,0],[1,"UnitCell",0,"GeometricUtilities.UnitCellBuilder",0],[1,"VoronoiItemList",0,"GeometricUtilities.VoronoiItemListBuilder",0],[0,"VoronoiRandomizationFactor",1,1],[1,"VoronoiRandomizationFactorExpression",0,"Expression",0],[1,"VoronoiRodDiameter",0,"Expression",0],[0,"VoronoiUniform",1,0]],[],[]];
SPLM.Features.Lattice2Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Lattice2Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Lattice2Builder.LatticeTypes = Object.freeze({
    "UnitGraph" : "UnitGraph", "ConformalGraph" : "ConformalGraph", "SurfaceGraph" : "SurfaceGraph", "TetrahedronGraph" : "TetrahedronGraph", "Voronoi" : "Voronoi", "UnitHexahedronFillGraph" : "UnitHexahedronFillGraph"});

SPLM.Features.Lattice2Builder.ThicknessTypes = Object.freeze({
    "RodDiameter" : "RodDiameter", "Density" : "Density"});

SPLM.Features.Lattice2Builder.ParameterizationType = Object.freeze({
    "Automatic" : "Automatic", "Planar" : "Planar", "Contour" : "Contour", "Cylindrical" : "Cylindrical", "CurveAligned" : "CurveAligned"});

SPLM.Features.Lattice2Builder.Version = Object.freeze({
    "V1" : "V1", "V2" : "V2"});

SPLM.Features.Lattice2Builder.BaseMeshType = Object.freeze({
    "UseExisting" : "UseExisting", "RemeshTriangular" : "RemeshTriangular"});

SPLM.Features.Lattice2Builder.FacetSizeType = Object.freeze({
    "Constant" : "Constant", "Variable" : "Variable"});

SPLM.Features.Lattice2Builder.SharpEdgesLockType = Object.freeze({
    "NoLock" : "NoLock", "SoftLock" : "SoftLock", "HardLock" : "HardLock"});

SPLM.Features.Lattice2Builder.BallsOptions = Object.freeze({
    "None" : "None", "AbsoluteSize" : "AbsoluteSize", "RelativeSize" : "RelativeSize", "OnlyOrganicBlends" : "OnlyOrganicBlends"});

SPLM.Features.Lattice2Builder.OutputOption = Object.freeze({
    "Surface" : "Surface", "Volume" : "Volume", "SurfaceAndVolume" : "SurfaceAndVolume"});

export default SPLM;